import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface OptimisticSignUpState {
  isLoading: boolean;
  setStatus: (status: boolean) => void;
}

// This store is used to manage the sign up status of the patient
// Since the sign up is slow on BE side we optimistically sign up the patient
export const useOptimisticSignUpStore = create<OptimisticSignUpState>()(
  persist(
    (set) => ({
      isLoading: false,
      setStatus: (isLoading) => set(() => ({ isLoading })),
    }),
    { name: 'optimistic-sign-up' },
  ),
);

export const clearOptimisticSignUpStore = () => useOptimisticSignUpStore.persist.clearStorage();
